import fieldGenerator from './generic-field';
export default fieldGenerator('text');
